/**
 * Created by methee on 8/30/17.
 */
/* eslint-disable  no-shadow, camelcase */
import React from 'react';
import { defineMessages } from 'react-intl';
import gql from 'graphql-tag';

import Layout from '../../components/Layout';
import Hotel from './Hotel';
import { HOTEL_INFO } from '../../constants';

const messages = defineMessages({
  title: {
    id: 'title.hotel',
    defaultMessage:
      '##Red Planet {hotelName} - Great location, Unbeatable value##',
    description: 'Hotel page name showing on browser tap',
  },
});

async function action({ meta, intl, client, query, store }, { hotel }) {
  const getHotel = async ({ check_in, check_out, code }) => {
    let search = '';
    if (check_in && check_out) {
      search += `checkIn: "${check_in}" checkOut: "${check_out}"`;
    }
    if (code) {
      search += `code:"${code}"`;
    }
    const HotelQuery = gql`query Hotel{
    hotel(hotelSlug: "${hotel}" doNotShowSoldOut: 1 ${search}){
    id
    name
    name_en
    slug_name
    seekda_id
    helpshift_tag
    description
    currency
    code
    address
    phone
    email
    default_image
    images
    start_price
    start_price_remembered
    opening_date
    opening_soon
    check_in
    check_out
    coordinate
    features {
      code
    }
    usp {
      icon
      description
    }
    location {
      id
      display_name
    }
    breakfast{
      name
      price_per_guest
      price_per_guest_no_tax
    }
    smoking{
      hotel_id
      price_per_night
    }
    pet_friendly{
      hotel_id
      price_per_night
    }
    rooms{
      id
      name
      code
      description
      images
      available
      limit_capacity
      guest_combination{
        adult
        child
      }
      rate {
        id
        name
        code
        available_rates {
          limit_guest
          selling_rate_non_member {
            price
            additional_amount_adult
            additional_amount_child
            price_no_tax
            additional_amount_adult_no_tax
            additional_amount_child_no_tax
          }
          selling_rate_member {
            price
            additional_amount_adult
            additional_amount_child
            price_no_tax
            additional_amount_adult_no_tax
            additional_amount_child_no_tax
          }
          selling_rate_non_member_pay_at_hotel{
            price
            additional_amount_adult
            additional_amount_child
            price_no_tax
            additional_amount_adult_no_tax
            additional_amount_child_no_tax
          }
          selling_rate_member_pay_at_hotel{
            price
            additional_amount_adult
            additional_amount_child
            price_no_tax
            additional_amount_adult_no_tax
            additional_amount_child_no_tax
          }
        }
      }
    }
    user_contents{
      info{
        number_of_reviews
        total_reviews
        rating
        comment
      }
      reviews{
        title
        message
        rating
        rating_image_url
        is_machine_translated
        review_at
        review_url
        user{
          username
          avatar_large_url
        }
      }
      tags{
        tag
        score
        mention_count
      }
    }
    policy_guarantee{
      pay_now_rules
      pay_later_rules
      expire_time
    }
    }
    }`;

    const { data } = await client.networkInterface.query({
      query: HotelQuery,
    });

    return data.hotel;
  };

  const h = await getHotel(query);
  if (!h) {
    return { redirect: '/hotels' };
  }

  await store.dispatch({ type: HOTEL_INFO, payload: h });

  const getNearby = async (hotelId, category) => {
    const NearbyQuery = gql`query Nearby{
    nearby(hotelId: ${hotelId} category: "${category}"){
    place{
      source,
      name,
      category_name,
      sub_category_name,
      type,
      telephone,
      url,
      website,
      coordinate,
      is_featured,
      promotion_text,
      image,
    }
    }
    }`;
    const { data } = await client.networkInterface.query({
      query: NearbyQuery,
    });
    return data.nearby ? data.nearby.place : [];
  };

  const LocationQuery = gql`
    query Location {
      locations(includeHotels: false) {
        id
        name
        name_en
        image_path
        images
        children {
          id
          name
          name_en
          image_path
          children {
            id
          }
        }
      }
    }
  `;
  const {
    data: { locations },
  } = await client.networkInterface.query({
    query: LocationQuery,
  });
  return {
    chunks: ['hotel'],
    metaTitle: meta[intl.locale][`hotel_${h.code.toLowerCase()}_meta_title`]
      ? meta[intl.locale][`hotel_${h.code.toLowerCase()}_meta_title`].message
      : intl.formatMessage(messages.title),
    forcedTitle: meta[intl.locale][`hotel_${h.code.toLowerCase()}_title`]
      ? meta[intl.locale][`hotel_${h.code.toLowerCase()}_title`].message
      : intl.formatMessage(messages.title, {
          hotelName: h.name,
        }),
    description: meta[intl.locale][
      `hotel_${h.code.toLowerCase()}_meta_description`
    ]
      ? meta[intl.locale][`hotel_${h.code.toLowerCase()}_meta_description`]
          .message
      : '',
    titleBody: meta[intl.locale][`hotel_${h.code.toLowerCase()}_title_body`]
      ? meta[intl.locale][`hotel_${h.code.toLowerCase()}_title_body`].message
      : '',
    component: (
      <Layout noMobileFooter>
        <Hotel
          hotel={h}
          locations={locations}
          getHotel={getHotel}
          getNearby={getNearby}
          query={query}
        />
      </Layout>
    ),
  };
}

export default action;
